import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-future-tech',
  templateUrl: './future-tech.component.html',
  styleUrls: ['./future-tech.component.css']
})
export class FutureTechComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
